if (!customElements.get("media-gallery")) {
  customElements.define(
    "media-gallery",
    class MediaGallery extends HTMLElement {
constructor() {
  super();
  this.selectors = {
    container: ".m-main-product--wrapper",
    slider: ".m-media-gallery__inner",
    sliderPagination: ".swiper-pagination",
    sliderPrevEl: ".swiper-button-prev",
    sliderNextEl: ".swiper-button-next",
    navSlider: ".nav-swiper-container",
    medias: [".m-product-media--item"],
    mediaWrapper: ".m-product-media--wrapper",
    mediaZoomIns: [".m-product-media__zoom-in"],
    videos: [".media-video"],
    featuredImage: ".m-product-media",
    galleryList: ".m-media-gallery__list",
    galleryInner: ".m-media-gallery__inner",
  };

  this.navSlider = false;
  this.slider = false;
this.thumbClicksBound = false;
this.thumbSliderScheduled = false;
this.thumbSliderInitialized = false;
this.thumbItems = null;
this.photoswipeClickBound = false;
this.hasPlayableMedia = false;
this.hasModelMedia = false;
this.onThumbClick = this.onThumbClick.bind(this);
}

      get context() {
        return this.dataset.context;
      }

      get layout() {
        return this.dataset.layout;
      }

      connectedCallback() {
        this.init();
      }

      init() {
        this.section = this.closest('product-info');
        this.domNodes = queryDomNodes(this.selectors, this);
        this.hasPlayableMedia = !!this.querySelector(
  '[data-media-type="video"], [data-media-type="external_video"], [data-media-type="model"]'
);

this.hasModelMedia = !!this.querySelector('[data-media-type="model"]');
        this.enableVideoAutoplay = this.dataset.enableVideoAutoplay === "true";
        this.enableImageZoom = this.dataset.enableImageZoom === "true";
        this.enableVariantGroupImages = this.dataset.enableVariantGroupImages === "true";
        this.onlyMedia = this.dataset.onlyMedia === "true";
        this.enableDesktopSlider = this.dataset.enableDesktopSlider === 'true';
        this.variantPicker = this.section.querySelector("variant-picker");

        this.setSliderOptions();

        const mql = window.matchMedia(MinimogTheme.config.mediaQueryMobile);
        mql.onchange = this.updateMediaLayout.bind(this);
        this.updateMediaLayout();

        if (this.enableImageZoom) {
  this.bindPhotoswipeClick();
}

        this.handleAutoplayVideo();

        this.removeAttribute("data-media-loading");
        this.domNodes.galleryInner.style.opacity = 1;
      }

updateMediaLayout() {
  if (this.onlyMedia) {
    this.destroySlider();
    return;
  }

  if (MinimogTheme.config.mqlMobile) {
    this.initSlider();
  } else {
    if (this.enableDesktopSlider) {
      this.initSlider();
    } else {
      this.destroySlider();
    }
  }
}

      setSliderOptions() {
        const { sliderPagination, sliderNextEl: nextEl, sliderPrevEl: prevEl } = this.domNodes;

        this.sliderOptions = {
          // Swiper's built-in autoHeight doesn't track the active slide
          // correctly once loop:true is also on (it locks onto the tallest
          // slide it has ever measured, incl. loop duplicates, and never
          // shrinks back down) — this left a gap below shorter images on
          // any product whose media mixes portrait + square/landscape
          // photos. We size the wrapper ourselves in syncGalleryHeight()
          // instead, driven by the true active slide's image ratio.
          autoHeight: false,
          navigation: { nextEl, prevEl },
          threshold: 2,
          loop: !this.enableVariantGroupImages,
          pagination: {
            el: sliderPagination,
            clickable: true,
            type: "bullets",
          },
         on: {
  init: () => {
    this.domNodes.slider.style.opacity = 1;
    this.domNodes = queryDomNodes(this.selectors, this.section);

    requestAnimationFrame(() => {
      if (this.slider && typeof this.slider.update === "function") {
        this.slider.update();
      }
      this.syncGalleryHeight();
    });
  },
  slideChangeTransitionEnd: () => {
    this.syncGalleryHeight();
  },
}
        };

        this.thumbsOptions = {
          loop: false,
          slidesPerView: 5,
          freeMode: true,
          spaceBetween: 10,
          threshold: 2,
          watchSlidesVisibility: true,
          watchSlidesProgress: true,
          on: {
            init: () => {
              this.domNodes.navSlider.style.opacity = 1
            }
          }
        };

        switch (this.layout) {
          case 'layout-4':
            break;
          case 'layout-5':
            this.sliderOptions = {
              ...this.sliderOptions,
              watchSlidesProgress: true,
              watchSlidesVisibility: true,
              breakpoints: {
                768: {
                  slidesPerView: 2,
                  slidesPerGroup: 1,
                  spaceBetween: 10,
                },
              }
            }
            break;
          case 'layout-6':
            this.thumbsOptions = {
              ...this.thumbsOptions,
              breakpoints: {
                1024: {
                  direction: 'vertical',
                  slidesPerView: 'auto',
                  spaceBetween: 5,
                }
              }
            }
            break;
          case 'layout-7':
            this.sliderOptions = {
              ...this.sliderOptions,
              speed: 500,
              centeredSlides: true,
              breakpoints: {
                768: {
                  slidesPerView: 3
                }
              }
            }
        }
      }

initSlider() {
  if (typeof this.slider !== 'object') {
    const { slider, galleryList, navSlider } = this.domNodes;
    const shouldDeferThumbSlider = MinimogTheme.config.mqlMobile;

    slider.classList.add('swiper-container');
    galleryList.classList.remove('m:grid');
    galleryList.classList.add('swiper-wrapper');

    if (!shouldDeferThumbSlider && navSlider) {
      this.initThumbSlider();
    } else {
      if (navSlider) {
        navSlider.style.opacity = 1;
      }
    }

    this.slider = new MinimogLibs.Swiper(slider, this.sliderOptions);

    this.bindThumbnailClicks();

    const activeIndex = typeof this.slider.realIndex === 'number'
      ? this.slider.realIndex
      : this.slider.activeIndex || 0;

    this.updateThumbActiveState(activeIndex);
    this.syncThumbPosition(activeIndex);

    if (!this.enableVariantGroupImages) this.handleSlideChange();

    if (shouldDeferThumbSlider && navSlider) {
      this.deferThumbSliderInit();
    }
  }
}

destroySlider() {
  const { slider, galleryList } = this.domNodes;

  slider.classList.remove('swiper-container');
  galleryList.classList.add('m:grid');
  galleryList.classList.remove('swiper-wrapper');

  if (typeof this.slider === 'object') {
    this.slider.destroy();
    this.slider = false;
  }

  if (typeof this.navSlider === 'object') {
    this.navSlider.destroy();
    this.navSlider = false;
  }

  this.thumbSliderScheduled = false;
  this.thumbSliderInitialized = false;
  this.thumbItems = null;
}

getSlideMethod() {
  return this.enableVariantGroupImages ? "slideTo" : "slideToLoop";
}

// Sets the gallery's height from the currently active slide's own image
// ratio (see the note on `autoHeight: false` above for why this replaces
// Swiper's built-in autoHeight). Safe to call any time — waits for the
// image to finish loading if it hasn't yet.
syncGalleryHeight() {
  if (!this.slider || !this.slider.wrapperEl || !this.slider.slides) return;

  const activeSlide = this.slider.slides[this.slider.activeIndex];
  if (!activeSlide) return;

  const img = activeSlide.querySelector('img');
  if (!img) return;

  const applyHeightFromRatio = (ratio) => {
    const numericRatio = Number(ratio);
    if (!numericRatio) return;
    const slideWidth = activeSlide.offsetWidth || parseFloat(activeSlide.style.width) || 0;
    if (!slideWidth) return;

    const height = Math.round(slideWidth / numericRatio);
    this.slider.wrapperEl.style.height = `${height}px`;
  };

  applyHeightFromRatio(activeSlide.dataset.aspectRatio);

  const applyHeight = () => {
    if (!img.naturalWidth || !img.naturalHeight) return;
    applyHeightFromRatio(img.naturalWidth / img.naturalHeight);
  };

  if (!img.complete) {
    img.addEventListener('load', applyHeight, { once: true });
  } else {
    applyHeight();
  }
}



bindThumbnailClicks() {
  if (this.thumbClicksBound) return;

  const thumbsRoot = this.querySelector(".m-product-media--slider__thumbnails");
  if (!thumbsRoot) return;

  thumbsRoot.addEventListener("click", this.onThumbClick, true);
  this.thumbClicksBound = true;
}

getCurrentMediaIndex() {
  if (!this.slider) return 0;
  if (typeof this.slider.realIndex === "number") return this.slider.realIndex;
  if (typeof this.slider.activeIndex === "number") return this.slider.activeIndex;
  return 0;
}

getMediaIndexFromElement(element) {
  if (!element) return 0;

  if (element.dataset.mediaId && this.slider && this.slider.slides) {
    const realSlides = Array.from(this.slider.slides).filter(
      (slide) => !slide.classList.contains("swiper-slide-duplicate")
    );
    const mediaIndex = realSlides.findIndex(
      (slide) => slide.dataset.mediaId === element.dataset.mediaId
    );

    if (mediaIndex > -1) return mediaIndex;
  }

  const index = element.dataset.index ?? element.getAttribute("data-swiper-slide-index");
  const parsedIndex = Number(index);

  return Number.isFinite(parsedIndex) ? parsedIndex : 0;
}

getMediaCount() {
  const realSlides = this.querySelectorAll(
    ".m-media-gallery__list > .m-product-media--item:not(.swiper-slide-duplicate)"
  );

  if (realSlides.length) return realSlides.length;
  return this.querySelectorAll(".m-product-media--slider__thumbnails [data-index]").length;
}

slideToMediaIndex(index, speed, runCallbacks = true) {
  if (!this.slider) return;

  const targetIndex = Number(index);
  if (!Number.isFinite(targetIndex)) return;

  this.slider.animating = false;

  const realSlides = Array.from(this.slider.slides || []).filter(
    (slide) => !slide.classList.contains("swiper-slide-duplicate")
  );
  const targetSlide = realSlides[targetIndex];
  const slideIndex = targetSlide
    ? Array.from(this.slider.slides).indexOf(targetSlide)
    : targetIndex;

  if (this.slider.params?.loop && typeof this.slider.slideTo === "function") {
    this.slider.slideTo(slideIndex, speed, runCallbacks);
  } else {
    const slideMethod = this.getSlideMethod();
    if (typeof this.slider[slideMethod] === "function") {
      this.slider[slideMethod](targetIndex, speed, runCallbacks);
    } else if (typeof this.slider.slideTo === "function") {
      this.slider.slideTo(targetIndex, speed, runCallbacks);
    }
  }

  this.updateThumbActiveState(targetIndex);
  this.syncThumbPosition(targetIndex);
  requestAnimationFrame(() => this.syncGalleryHeight());
}

onThumbClick(event) {
  const control = event.target.closest(".nyx-thumb-btn");
  if (control && this.contains(control)) {
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    if (control.disabled || !this.slider) return;

    const maxIndex = this.getMediaCount() - 1;
    if (maxIndex < 0) return;

    const currentIndex = this.getCurrentMediaIndex();
    const step = control.classList.contains("nyx-thumb-prev") ? -1 : 1;
    const targetIndex = Math.max(0, Math.min(currentIndex + step, maxIndex));

    this.slideToMediaIndex(targetIndex);
    return;
  }

  const thumb = event.target.closest(".m-product-media--slider__thumbnails [data-index]");
  if (!thumb || !this.slider) return;

  event.preventDefault();
  event.stopPropagation();
  event.stopImmediatePropagation();

  this.slideToMediaIndex(this.getMediaIndexFromElement(thumb));
}

updateThumbActiveState(index = 0) {
  if (!this.thumbItems) {
    this.thumbItems = Array.from(
      this.querySelectorAll(".m-product-media--slider__thumbnails [data-index]")
    );
  }

  this.thumbItems.forEach((thumb) => {
    thumb.classList.toggle(
      "swiper-slide-thumb-active",
      Number(thumb.dataset.index) === Number(index)
    );
  });
}

syncThumbPosition(index = 0) {
  if (!this.navSlider || typeof this.navSlider.slideTo !== "function") return;

  const targetIndex = Number(index);
  const currentIndex = typeof this.navSlider.activeIndex === "number"
    ? this.navSlider.activeIndex
    : -1;

  if (currentIndex === targetIndex) return;

  this.navSlider.slideTo(targetIndex, 0, false);
}

deferThumbSliderInit() {
  if (this.thumbSliderScheduled || this.thumbSliderInitialized) return;
  if (!this.domNodes.navSlider) return;

  this.thumbSliderScheduled = true;
  this.domNodes.navSlider.style.opacity = 1;

  const init = () => {
    if (this.thumbSliderInitialized || typeof this.navSlider === "object") return;
    this.initThumbSlider();
  };

  requestAnimationFrame(() => {
    requestAnimationFrame(init);
  });
}

initThumbSlider() {
  if (this.thumbSliderInitialized) return;
  if (!this.domNodes.navSlider) return;

  this.navSlider = new MinimogLibs.Swiper(this.domNodes.navSlider, this.thumbsOptions);

  this.thumbSliderInitialized = true;

  const activeIndex = this.slider
    ? (typeof this.slider.realIndex === "number"
        ? this.slider.realIndex
        : this.slider.activeIndex || 0)
    : 0;

  this.updateThumbActiveState(activeIndex);
  this.syncThumbPosition(activeIndex);
}

handleSlideChange() {
  if (!this.slider) return;

  this.slider.on("slideChange", (swiper) => {
    const { slides, activeIndex } = swiper;
    const realIndex = typeof swiper.realIndex === "number" ? swiper.realIndex : activeIndex;

    this.updateThumbActiveState(realIndex);
    this.syncThumbPosition(realIndex);

    if (this.hasPlayableMedia) {
      window.pauseAllMedia(this);

      const activeSlide = slides[activeIndex];
      if (activeSlide) this.playActiveMedia(activeSlide);
    }

    if (this.hasModelMedia) {
      const visibleSlides = [activeIndex];

      if (["layout-5", "layout-7"].includes(this.layout)) {
        visibleSlides.push(activeIndex + 1);
      }

      const hasModelMediaType = visibleSlides.some((index) => {
        const slide = slides[index];
        return slide && slide.dataset.mediaType === "model";
      });

      this.toggleSliderDraggableState(!hasModelMediaType);
    }
  });
}

toggleSliderDraggableState(isDraggable = true) {
  if (!this.slider) return;
  this.slider.allowTouchMove = !!isDraggable;
}

handleAutoplayVideo() {
        const playVideo = (mediaElement) => {
          const mediaType = mediaElement.dataset.mediaType;
          if (mediaType === "video" || mediaType === "external_video") {
            const deferredMedia = mediaElement.querySelector("deferred-media");
            const autoplay = deferredMedia && deferredMedia.dataset.autoPlay === "true";
            if (autoplay) deferredMedia.loadContent(false);
          }
        };

        if (this.slider) {
          const { slides, activeIndex } = this.slider;
          const activeSlide = slides[activeIndex];
          if (activeSlide) playVideo(activeSlide);
        } else {
          this.domNodes.medias.forEach(playVideo);
        }
      }

      playActiveMedia(selected) {
        const deferredMedia = selected.querySelector("deferred-media");
        if (!deferredMedia || deferredMedia.dataset.autoPlay !== "true") return;

        const playMedia = (element) => {
          if (element.classList.contains("js-youtube") || element.classList.contains("js-vimeo")) {
            const platform = element.classList.contains("js-youtube") ? "youtube" : "vimeo";
            const param = platform === "youtube" ? "mute=1" : "muted=1";
            const symbol = element.src.includes("?") ? "&" : "?";
            element.src += `${symbol}autoplay=1&${param}`;
          } else {
            element.play();
          }
        };

        if (!deferredMedia.hasAttribute("loaded")) {
          deferredMedia.loadContent(false);
        }

        const deferredElement = deferredMedia.querySelector("video, model-viewer, iframe");
        playMedia(deferredElement);
      }

      bindPhotoswipeClick() {
  if (this.photoswipeClickBound) return;
  this.photoswipeClickBound = true;

  addEventDelegate({
    selector: this.selectors.medias[0],
    context: this,
    handler: (e, media) => {
      const isImage = media.classList.contains("media-type-image");
      const isZoomButton = e.target.closest(this.selectors.mediaZoomIns[0]);

      if (!isImage && !isZoomButton) return;

      e.preventDefault();

      const index = this.getMediaIndexFromElement(media);

      if (!this.lightbox) {
        this.handlePhotoswipe();
      }

      if (this.lightbox) {
        this.lightbox.loadAndOpen(index);
      }
    },
  });
}

      handlePhotoswipe() {
        const medias = [...this.querySelectorAll(".m-product-media--item:not(.swiper-slide-duplicate)")];

        const data = medias.map((media) => {
          const { mediaType, index: id } = media.dataset;

          if (mediaType === "image") {
            const {
              mediaSrc: src,
              mediaWidth,
              mediaHeight,
              mediaAlt: alt,
            } = media.querySelector(".m-product-media").dataset;
            return {
              src,
              width: parseInt(mediaWidth),
              height: parseInt(mediaHeight),
              alt,
              id,
            };
          } else {
            return {
              html: `<div class="pswp__${mediaType}">${media.innerHTML}</div>`,
              type: mediaType,
              id,
            };
          }
        });

        const options = {
          dataSource: data,
          bgOpacity: 1,
          close: false,
          zoom: false,
          arrowNext: false,
          arrowPrev: false,
          counter: false,
          preloader: false,
          pswpModule: MinimogLibs.PhotoSwipeLightbox.PhotoSwipe,
        };
        this.lightbox = new MinimogLibs.PhotoSwipeLightbox(options);

        this.lightbox.addFilter("thumbEl", (thumbEl, { id }, index) => {
          return this.querySelector(`[data-index="${id}"]:not(.swiper-slide-duplicate) img`) || thumbEl;
        });

        this.lightbox.addFilter("placeholderSrc", (placeholderSrc, { data: { id } }) => {
          const el = this.querySelector(`[data-index="${id}"]:not(.swiper-slide-duplicate) img`);
          return el ? el.src : placeholderSrc;
        });

        this.lightbox.on("change", () => {
          window.pauseAllMedia(this);
          if (this.slider) {
            const { currIndex } = this.lightbox.pswp;
            this.slideToMediaIndex(currIndex, 100, false);
          }
        });

        this.lightbox.on("pointerDown", (e) => {
          if (this.lightbox.pswp.currSlide.data.type === "model") {
            e.preventDefault();
          }
        });

        // UI elements
        const uiElements = [
          {
            name: "m-close",
            order: 11,
            isButton: true,
            html: '<svg class="m-svg-icon--large" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path></svg>',
            onClick: (event, el, pswp) => pswp.close(),
          },
          {
            name: "m-arrowNext",
            order: 12,
            isButton: true,
            html: '<svg fill="currentColor" width="14px" height="14px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M218.101 38.101L198.302 57.9c-4.686 4.686-4.686 12.284 0 16.971L353.432 230H12c-6.627 0-12 5.373-12 12v28c0 6.627 5.373 12 12 12h341.432l-155.13 155.13c-4.686 4.686-4.686 12.284 0 16.971l19.799 19.799c4.686 4.686 12.284 4.686 16.971 0l209.414-209.414c4.686-4.686 4.686-12.284 0-16.971L235.071 38.101c-4.686-4.687-12.284-4.687-16.97 0z"></path></svg>',
            onClick: (event, el, pswp) => pswp.next(),
          },
          {
            name: "m-arrowPrev",
            order: 10,
            isButton: true,
            html: '<svg width="14px" height="14px" fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M229.9 473.899l19.799-19.799c4.686-4.686 4.686-12.284 0-16.971L94.569 282H436c6.627 0 12-5.373 12-12v-28c0-6.627-5.373-12-12-12H94.569l155.13-155.13c4.686-4.686 4.686-12.284 0-16.971L229.9 38.101c-4.686-4.686-12.284-4.686-16.971 0L3.515 247.515c-4.686 4.686-4.686 12.284 0 16.971L212.929 473.9c4.686 4.686 12.284 4.686 16.971-.001z"></path></svg>',
            onClick: (event, el, pswp) => pswp.prev(),
          },
        ];

        this.lightbox.on("uiRegister", () => {
          this.lightbox.pswp.ui.registerElement(uiElements[0]);
          if (!this.onlyMedia) {
            uiElements.slice(1).forEach((element) => this.lightbox.pswp.ui.registerElement(element));
          }
        });

       this.lightbox.init();
}

      setActiveMedia(variant) {
        if (!variant) return;
        if (this.slider) {
          this.setActiveMediaForSlider(variant);
        } else {
          this.handleGalleryMode(variant);
        }
      }

      setActiveMediaForSlider(variant) {
        if (variant.featured_media && this.slider && this.slider.wrapperEl) {
          let slideIndex = variant.featured_media.position || 1;
          this.slider.slideToLoop(slideIndex - 1);
          requestAnimationFrame(() => this.syncGalleryHeight());
        }
      }

      handleGalleryMode(variant) {
        if (this.context !== "featured-product" && variant && variant.featured_media) {
          const selectedMedia = this.querySelector(`.m-media-gallery__list [data-media-id="${variant.featured_media.id}"]`);
          if (selectedMedia) {
            this.scrollIntoView(selectedMedia);
          }
        }
      }

      scrollIntoView(selectedMedia) {
        selectedMedia.scrollIntoView({
          behavior: "smooth",
        });
      }
    }
  );
}
